import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import interviewFetched, {
	type InterviewFetchedAction,
} from '@Application/Beneficiaries/Interviews/Actions/interviewFetched';
import interviewFetchFailed, {
	type InterviewFetchFailedAction,
} from '@Application/Beneficiaries/Interviews/Actions/interviewFetchFailed';
import type { InterviewPayload } from '@Application/Beneficiaries/Interviews/Actions/interviewsFetched';
import type FetchInterview from '@Application/Beneficiaries/Interviews/Queries/FetchInterview';
import { get } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = InterviewFetchedAction | InterviewFetchFailedAction;

export default (query: FetchInterview) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<InterviewPayload>(
				`${buildSubjectApiPath(query.facilityId, query.subject)}/interviews/${query.interviewId}`,
			);

			const action = interviewFetched(payload, query.facilityId, query.subject.subjectId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = interviewFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
